import React, { useEffect, useState } from 'react';
import './ManageItems.scss';
import StallItemForm from '../StallItemForm/StallItemForm';
import StallItemBatchForm from '../StallItemBatchForm/StallItemBatchForm';
import CommunityCapsules from './CommunityCapsules';
import StallItemSettings from '../StallItemSettings/StallItemSettings';
import { http, localstorage, FxSelect, useNavigationService, session, general, AlertService } from '../../fx-core';
import { Drawer, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Fab, Button, TextField, Checkbox, Breadcrumbs, Typography, Dialog } from '@material-ui/core';
import Badge from '@material-ui/core/Badge';
import _ from 'lodash';
import { NoRecords } from '../../NoRecords/NoRecords';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import NewCategoryItemForm from '../CreateServiceRequestContainer/NewCategoryItemForm/NewCategoryItemForm';

const styles = makeStyles((theme) => ({
  drawerWidth: {
    [theme.breakpoints.down(599)]: {
      width: '90%'
    },
    [theme.breakpoints.up(600)]: {
      width: '70%'
    },
    [theme.breakpoints.up(1025)]: {
      width: '40%'
    }
  },
  marginInput: {
    width: '70px',
    '& .MuiOutlinedInput-input': {
      padding: '4px 6px',
      fontSize: '12px',
      textAlign: 'center'
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      backgroundColor: '#fafafa'
    }
  },
  actionBtn: {
    height: '36px',
    borderRadius: '18px',
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'none',
    padding: '0 14px',
    marginRight: '10px'
  },
  postAffiliateBtn: {
    backgroundColor: '#ff6f00',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#e65100'
    }
  },
  viewResellerBtn: {
    borderColor: '#ff6f00',
    color: '#ff6f00',
    '&:hover': {
      borderColor: '#e65100',
      backgroundColor: 'rgba(255, 111, 0, 0.05)'
    }
  }
}));

const ManageItems = (props) => {
  const { navigate, navigateRoot } = useNavigationService();
  const classes = styles();
  let defaultContext = { stallId: 0 };
  const [currentContext, setCurrentContext] = useState(defaultContext);
  const [communityId] = useState(parseInt(localstorage.getItem("communityId") || "0"));
  const [userId] = useState(parseInt(localstorage.getItem("userId") || "0"));
  const [stalls, setStalls] = useState([]);
  const [stallItems, setStallItems] = useState([]);

  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedCategoryName, setSelectedCategoryName] = useState(null);
  const [showAffiliatedOnly, setShowAffiliatedOnly] = useState(false);

  const [stallItemId, setStallItemId] = useState(0);
  const [stallItemFormOpen, setStallItemFormOpen] = useState(false);
  const [stallItemBatchFormOpen, setStallItemBatchFormOpen] = useState(false);
  const [stallItemSettingsOpen, setStallItemSettingsOpen] = useState(false);
  const [stallServiceMapList, setStallServiceMapList] = useState([]);

  const [affiliateState, setAffiliateState] = useState<{ [key: number]: { isAffiliateEnabled: boolean; marginNumber: string | number; isModified?: boolean } }>({});
  const [isSavingAffiliate, setIsSavingAffiliate] = useState(false);

  const [isRemovingAffiliate, setIsRemovingAffiliate] = useState<number | null>(null);

  const [postedAffiliateIds, setPostedAffiliateIds] = useState<number[]>([]);

  const [stallSpecialCommunities, setStallSpecialCommunities] = useState([]);
  const [itemCommunityOverrides, setItemCommunityOverrides] = useState({});

  const [newCatItemFormOpen, setNewCatItemFormOpen] = useState(false);
  const [newCatFormServiceId, setNewCatFormServiceId] = useState(0);
  const [newCatFormServiceRequestType, setNewCatFormServiceRequestType] = useState(null);

  const [pendingAdditions, setPendingAdditions] = useState<any[]>([]);
const [showPendingOnly, setShowPendingOnly] = useState(false);
const [addingId, setAddingId] = useState<number | null>(null);
const [viewLayout, setViewLayout] = useState<'table' | 'grid'>('table');
const [imageViewerOpen, setImageViewerOpen] = useState(false);
const [viewerImage, setViewerImage] = useState('');
const [zoomLevel, setZoomLevel] = useState(1);

const getPendingAdditions = () => {
  http.get({ url: 'affiliate-product/my-pending-additions' }).then(res => {
    setPendingAdditions(res.data || []);
  }).catch(() => setPendingAdditions([]));
};

const handleAddPendingItem = (affiliateProductId: number) => {
  setAddingId(affiliateProductId);
  http.post({ url: `affiliate-product/${affiliateProductId}/add-to-stall` }).then(() => {
    setAddingId(null);
    AlertService.showSuccessMsg("Added to your stall!");
    getPendingAdditions();
    getStallItems(currentContext.stallId);
  }).catch(() => {
    setAddingId(null);
    AlertService.showErrorMsg && AlertService.showErrorMsg("Could not add — check you have a stall set up.");
  });
};
  const handleCurrentContext = (item) => {
    handleCurrentContextChange({ [item.name]: item.value });
    getStallItems(item.value);
  };

  const handleCurrentContextChange = (data) => {
    setCurrentContext(prevState => ({ ...prevState, ...data }));
  };

  const initLookup = () => {
    let inputData = {
      lookups: { ProviderStalls: { default: false } },
      filters: { communityId: communityId, userId: userId }
    };
    http.post({ url: 'options/lookup', data: inputData }).then(response => {
      const result = response.data.ProviderStalls;
      setStalls(result);
      let defaultStallId = result.length > 0 ? result[0].id : 0;
      handleCurrentContextChange({ stallId: defaultStallId });
      if (defaultStallId > 0) getStallItems(defaultStallId);
    });
  };

  const getStallCommunityData = (stallId) => {
    http.get({ url: `stallitem/stall/${stallId}/specialcommunities` })
      .then((res: any) => {
        setStallSpecialCommunities(res.data || []);
      })
      .catch(() => setStallSpecialCommunities([]));

    http.get({ url: `stallitem/stall/${stallId}/communityoverrides` })
      .then((res: any) => {
        setItemCommunityOverrides(res.data || {});
      })
      .catch(() => setItemCommunityOverrides({}));
  };

  const getStallItems = (id) => {
    http.get({ url: `stallitem/stall/${id}` }).then(res => {
      const result = res.data || [];
      setStallItems(result);

            const initialAffiliate: any = {};
      result.forEach(si => {
        const itemId = si.StallItemId ?? si.Id ?? si.stallItemId;
        const wasAlreadyEnabled = si.IsAffiliateEnabled ?? si.isAffiliateEnabled ?? false;
        initialAffiliate[itemId] = {
          isAffiliateEnabled: wasAlreadyEnabled,
          marginNumber: si.MarginNumber ?? si.marginNumber ?? '',
          isModified: false,
          // Snapshot of server state at load time — once true, this item is
          // already live/posted and its margin must not be editable anymore,
          // since a reseller may have already cloned it with this rate.
          alreadyPosted: wasAlreadyEnabled
        };
      });
      setAffiliateState(initialAffiliate);

            // Track which items are already posted as affiliate
      const postedIds = result
        .filter((si: any) => si.IsAffiliateEnabled ?? si.isAffiliateEnabled ?? false)
        .map((si: any) => si.StallItemId ?? si.Id ?? si.stallItemId);
      setPostedAffiliateIds(postedIds);

      const catsById = {};
      result.forEach(si => {
        const cats = si.Categories || si.categories || [];
        if (Array.isArray(cats) && cats.length > 0) {
          cats.forEach(c => {
            const cid = c.Id ?? c.id ?? c.CategoryId ?? c.categoryId ?? null;
            const cname = c.CategoryName ?? c.categoryName ?? c.Name ?? c.name ?? c.DisplayName ?? `${cid}`;
            if (cid !== null && cid !== undefined) {
              catsById[cid] = { id: cid, name: cname };
            }
          });
        }
      });
      const catsArr = Object.values(catsById);
      setCategories(catsArr);
      setSelectedCategoryId(null);
    });

    getStallCommunityData(id);
  };

  const handleAffiliateToggle = (itemId: number) => {
    setAffiliateState(prev => {
      const current = prev[itemId] || { isAffiliateEnabled: false, marginNumber: '' };
      const nextEnabled = !current.isAffiliateEnabled;
      return {
        ...prev,
        [itemId]: {
          ...current,
          isAffiliateEnabled: nextEnabled,
          marginNumber: nextEnabled ? (current.marginNumber || '10') : '',
          isModified: true
        }
      };
    });
  };

  const handleMarginInputChange = (itemId: number, value: string) => {
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setAffiliateState(prev => {
        const current = prev[itemId] || { isAffiliateEnabled: true, marginNumber: '' };
        return {
          ...prev,
          [itemId]: {
            ...current,
            marginNumber: value,
            isModified: true
          }
        };
      });
    }
  };

  const handlePostAffiliatedProducts = () => {
    const invalidItems = Object.entries(affiliateState).filter(([id, data]) => {
      if (data.isAffiliateEnabled) {
        const margin = parseFloat(data.marginNumber as string);
        return isNaN(margin) || margin <= 0;
      }
      return false;
    });


    if (invalidItems.length > 0) {
      AlertService.showErrorMsg && AlertService.showErrorMsg("Please enter a valid margin (> 0%) for all enabled affiliate products.");
      return;
    }

    const payload = Object.entries(affiliateState).map(([id, data]) => ({
      StallItemId: parseInt(id),
      IsAffiliateEnabled: data.isAffiliateEnabled,
      MarginNumber: data.isAffiliateEnabled ? parseFloat(data.marginNumber as string) : 0
    }));

    setIsSavingAffiliate(true);
    http.post({
      url: 'stallitem/affiliate/save',
      data: {
        stallId: currentContext.stallId,
        affiliateItems: payload
      }
      }).then(res => {
      setIsSavingAffiliate(false);
      
      // Save the IDs that were just posted as affiliate-enabled
      const postedIds = Object.entries(affiliateState)
        .filter(([id, data]) => data.isAffiliateEnabled)
        .map(([id]) => parseInt(id));
      setPostedAffiliateIds(postedIds);
      
      AlertService.showSuccessMsg("Affiliated products posted successfully!");
      getStallItems(currentContext.stallId);
    }).catch(err => {
      setIsSavingAffiliate(false);
      AlertService.showErrorMsg && AlertService.showErrorMsg("Failed to post affiliated products.");
    });
  };
    const handleRemoveAffiliate = (itemId: number) => {
    setIsRemovingAffiliate(itemId);
    
    const payload = Object.entries(affiliateState).map(([id, data]) => ({
      StallItemId: parseInt(id),
      IsAffiliateEnabled: parseInt(id) === itemId ? false : data.isAffiliateEnabled,
      MarginNumber: parseInt(id) === itemId ? 0 : (data.isAffiliateEnabled ? parseFloat(data.marginNumber as string) : 0)
    }));
    
    http.post({
      url: 'stallitem/affiliate/save',
      data: {
        stallId: currentContext.stallId,
        affiliateItems: payload
      }
    }).then(res => {
      setIsRemovingAffiliate(null);
      AlertService.showSuccessMsg("Product removed from affiliate marketing!");
      getStallItems(currentContext.stallId);
    }).catch(err => {
      setIsRemovingAffiliate(null);
      AlertService.showErrorMsg && AlertService.showErrorMsg("Failed to remove product from affiliate marketing.");
    });
  };

  const handleViewResellerStall = () => {
    const stallObj = stalls.find((s: any) => s.id === currentContext.stallId);
    const stallSlug = (stallObj?.text || 'delizfoodies').toLowerCase().replace(/\s+/g, '');
    navigate({
      targetRoute: `/resellerstalls/${stallSlug}`,
      targetTitle: "Reseller Stall",
      targetData: {},
      sourceState: {},
      eventSource: ''
    });
  };
 const navToResellerStalls = () => {
    navigate({
        targetRoute: `/provider/affiliatemarketing`,
        targetTitle: "Affiliated Products",
        targetData: {},
        sourceState: {},
        eventSource: ''
    });
};

  const openStallItemForm = (id) => { setStallItemId(id); setStallItemFormOpen(true); };
  const handleStallItemFormClose = () => { setStallItemFormOpen(false); getStallItems(currentContext.stallId); };

  const openStallItemBatchList = (id) => {
    navigate({
      targetRoute: '/provider/stallitembatchlist/' + id,
      targetTitle: "Stall Item Batch List",
      targetData: {},
      sourceState: {},
      eventSource: '',
    });
  };

  const openStallItemBatchForm = (id) => { setStallItemId(id); setStallItemBatchFormOpen(true); };
  const handleStallItemBatchFormClose = () => { setStallItemBatchFormOpen(false); getStallItems(currentContext.stallId); };

  const openStallItemSettings = (id) => { setStallItemId(id); setStallItemSettingsOpen(true); };
  const handleStallItemSettingsClose = () => { setStallItemSettingsOpen(false); getStallItems(currentContext.stallId); };

    const openStallItemCustomize = (id) => {
    navigate({
      targetRoute: '/provider/stallitemcustomize/' + id,
      targetTitle: "Stall Item Customize",
      targetData: {},
      sourceState: {},
      eventSource: '',
    });
  };

  const goToAffiliatePreview = () => {
    // Tell the Affiliate Products page to open already filtered to "My Products"
    sessionStorage.setItem('affiliateProductFilter', 'mine');
    navigate({
      targetRoute: '/provider/affiliatemarketing',
      targetTitle: "Affiliated Products",
      targetData: {},
      sourceState: {},
      eventSource: '',
    });
  };

  const getStallServiceMapList = () => {
    let inputData = { filters: { communityId: communityId, userId: userId, serviceStallsOnly: true } };
    http.post({ url: 'stall/providerstalls/withservicemap', data: inputData }).then(res => {
      setStallServiceMapList(res.data.providerStalls || []);
    });
  };

  useEffect(() => {
  initLookup();
  getStallServiceMapList();
  getPendingAdditions();
}, []);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const updatedList = Array.from(stallItems);
    const [moved] = updatedList.splice(result.source.index, 1);
    updatedList.splice(result.destination.index, 0, moved);
    setStallItems(updatedList);

    const payload = updatedList.map((row, idx) => {
      const id = row.StallItemId ?? row.Id ?? row.stallItemId ?? null;
      return id ? { Id: id, DisplayOrder: idx + 1 } : null;
    }).filter(x => x);

    if (payload.length === 0) return;

    http.post({
      url: "stallitem/displayorder/save",
      data: { stallItems: payload }
    }).then(() => {
      AlertService.showSuccessMsg("Order updated");
    }).catch(() => {
      AlertService.showErrorMsg && AlertService.showErrorMsg("Failed to update order");
    });
  };

  const visibleItems = stallItems.filter(si => {
    const primaryId = si.StallItemId ?? si.Id ?? si.stallItemId;
    const isAffiliate = affiliateState[primaryId]?.isAffiliateEnabled ?? false;

    if (showAffiliatedOnly && !isAffiliate) {
      return false;
    }

    if (selectedCategoryId) {
      const cats = si.Categories || si.categories || [];
      if (Array.isArray(cats) && cats.length > 0) {
        return cats.some(c => {
          const cid = c.Id ?? c.id ?? c.categoryId;
          return cid === selectedCategoryId;
        });
      }
      if (Array.isArray(si.CategoryIds) && si.CategoryIds.length > 0) {
        return si.CategoryIds.includes(selectedCategoryId);
      }
      return false;
    }

    return true;
  });

  const openNewCategoryForm = () => {
    const stallMap = _.find(stallServiceMapList, { id: currentContext.stallId });
    const serviceMap = stallMap?.stallServiceMapList || [];
    if (serviceMap && serviceMap.length === 1) {
      setNewCatFormServiceId(serviceMap[0].serviceId);
      setNewCatFormServiceRequestType(serviceMap[0].serviceRequestType || 'Sell');
    } else {
      setNewCatFormServiceId(0);
    }
    setNewCatItemFormOpen(true);
  };

  const handleNewCatFormClose = () => {
    setNewCatItemFormOpen(false);
    if (currentContext.stallId && currentContext.stallId > 0) {
      getStallItems(currentContext.stallId);
    }
  };

  const handleNewCatFormSave = (data) => {
    const incoming = (data && data.otherCategoryItems) ? data.otherCategoryItems : [];
    if (!incoming || incoming.length === 0) return;
  };

  const affiliatedCount = Object.values(affiliateState).filter(a => a.isAffiliateEnabled).length;

  return (
   <div className='manageitems-ui pt-5 mt-4'>
      {/* Sleek Native Title Header */}

      <div className="pt-3 px-4" style={{ backgroundColor: '#f5f1e8' }}>
  <Breadcrumbs aria-label="breadcrumb">
    <span
  className="pointer"
  style={{ color: '#f69516', textDecoration: 'underline', fontWeight: 'bold' }}
  onClick={() => navigateRoot({ targetRoute: '', targetTitle: 'Dashboard', targetData: {}, sourceState: {}, eventSource: '' })}
>
  Dashboard
</span>
    <Typography style={{ color: '#3c4858', fontWeight: 500 }}>Manage Items</Typography>
  </Breadcrumbs>
</div>

      <div className='mx-3 my-3'>
        <div className='row justify-content-between px-4 align-items-center'>
          <div className='pl-1'>
            <FxSelect name="stallId" variant="outlined" label="Select Stall"
              options={stalls}
              selectedValue={currentContext.stallId}
              valueField="id"
              displayField="text"
              size="small"
              style={{ width: 240 }}
              onValueChange={handleCurrentContext} />
          </div>

                    <div className='pr-4 row align-items-center'>

          {/* Promote & Earn only shows inside the Affiliate Options */}
          {showAffiliatedOnly && (
            <Button
              variant="outlined"
              className={`${classes.actionBtn} ${classes.viewResellerBtn}`}
              onClick={navToResellerStalls}
            >
              <i className="fas fa-store mr-2"></i>
              Promote & Earn
            </Button>
          )}

    <Button
      variant="contained"
      className={`${classes.actionBtn} ${classes.postAffiliateBtn}`}
      onClick={handlePostAffiliatedProducts}
      disabled={isSavingAffiliate}
    >
      <i className="fas fa-bullhorn mr-2"></i>
      {isSavingAffiliate ? 'Posting...' : `Post Affiliated (${affiliatedCount})`}
    </Button>
        <div className="view-toggle-group" style={{ display: 'flex', border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden', marginRight: 10 }}>
      <span
        className="pointer"
        onClick={() => setViewLayout('table')}
        title="Table View"
        style={{
          padding: '8px 12px',
          background: viewLayout === 'table' ? '#f69516' : '#fff',
          color: viewLayout === 'table' ? '#fff' : '#666'
        }}
      >
        <i className="fas fa-list"></i>
      </span>
      <span
        className="pointer"
        onClick={() => setViewLayout('grid')}
        title="Grid View"
        style={{
          padding: '8px 12px',
          background: viewLayout === 'grid' ? '#f69516' : '#fff',
          color: viewLayout === 'grid' ? '#fff' : '#666'
        }}
      >
        <i className="fas fa-th-large"></i>
      </span>
    </div>

    <div>
      <Fab variant="extended" size="medium" color="primary" onClick={openNewCategoryForm} style={{ height: '38px' }}>
        <i className="fas fa-plus pr-2"></i> Add
      </Fab>
    </div>
</div>
        </div>

        {/* Categories pills row */}
        <div className="my-3 px-2 categories-row" style={{ display: 'flex', gap: 8, alignItems: 'center', overflowX: 'auto', paddingTop: 6, paddingBottom: 6 }}>
          <button
            className={`category-pill ${selectedCategoryId === null && !showAffiliatedOnly ? 'active' : ''}`}
            onClick={() => { setSelectedCategoryId(null); setShowAffiliatedOnly(false); setShowPendingOnly(false); }}
            style={{
              padding: '5px 14px',
              borderRadius: 20,
              fontSize: '13px',
              border: '1px solid #ddd',
              background: selectedCategoryId === null && !showAffiliatedOnly ? '#f5a623' : '#fff',
              color: selectedCategoryId === null && !showAffiliatedOnly ? '#fff' : '#444'
            }}
          >
            All
          </button>

          {/* Clean Affiliated Pill */}
                    <button
            className={`category-pill ${showAffiliatedOnly ? 'active' : ''}`}
            onClick={() => { setShowAffiliatedOnly(!showAffiliatedOnly); setShowPendingOnly(false); setSelectedCategoryId(null); }}
            style={{
              padding: '5px 14px',
              borderRadius: 20,
              fontSize: '13px',
              border: '1px solid #ddd',
              background: showAffiliatedOnly ? '#f5a623' : '#fff',
              color: showAffiliatedOnly ? '#fff' : '#444',
              whiteSpace: 'nowrap'
            }}
          >
            Affiliated Products ({affiliatedCount})
          </button>

          <button
            className={`category-pill ${showPendingOnly ? 'active' : ''}`}
            onClick={() => { setShowPendingOnly(!showPendingOnly); setShowAffiliatedOnly(false); setSelectedCategoryId(null); }}
            style={{
              padding: '5px 14px', borderRadius: 20, fontSize: '13px', border: '1px solid #ddd',
              background: showPendingOnly ? '#f5a623' : '#fff',
              color: showPendingOnly ? '#fff' : '#444', whiteSpace: 'nowrap'
            }}
          >
            New From Merchants ({pendingAdditions.length})
          </button>

          {categories.length > 0 && (
            <div className="category-bar px-2" style={{ gap: 8, alignItems: 'center', overflowX: 'auto', display: 'flex' }}>
                            {categories.map(cat => (
                <button
                  key={cat.id}
                  onClick={() => {
                    setShowAffiliatedOnly(false);
                    setShowPendingOnly(false);
                    if (selectedCategoryId === cat.id) {
                      setSelectedCategoryId(null);
                      setSelectedCategoryName(null);
                    } else {
                      setSelectedCategoryId(cat.id);
                      setSelectedCategoryName(cat.name || cat.CategoryName || cat.categoryName || null);
                    }
                  }}
                  className={`category-pill ${selectedCategoryId === cat.id && !showAffiliatedOnly ? 'active' : ''}`}
                  style={{
                    padding: '5px 14px',
                    borderRadius: 20,
                    fontSize: '13px',
                    border: '1px solid #ddd',
                    background: selectedCategoryId === cat.id && !showAffiliatedOnly ? '#f5a623' : '#fff',
                    color: selectedCategoryId === cat.id && !showAffiliatedOnly ? '#fff' : '#444',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {cat.name || cat.CategoryName || cat.categoryName || `${cat.id}`}
                </button>
              ))}
            </div>
          )}
        </div>
{showPendingOnly && (
  <div className='col-12 my-3'>
    {pendingAdditions.length === 0 && <div className="text-center py-4 text-muted">No new items waiting to be added.</div>}
    {pendingAdditions.map((p: any) => {
  const pid = p.Id ?? p.id;
  const pItemName = p.ItemName ?? p.itemName ?? 'Unnamed item';
  const pMerchantName = p.MerchantStallName ?? p.merchantStallName ?? 'Unknown merchant';
  const pMargin = p.MarginNumber ?? p.marginNumber ?? 0;
  return (
    <div key={pid} className="d-flex justify-content-between align-items-center p-3 mb-2" style={{ border: '1px solid #eee', borderRadius: 8 }}>
      <div>
        <b>{pItemName}</b> — from {pMerchantName} ({pMargin}% commission)
      </div>
      <Button variant="contained" color="primary" size="small"
        onClick={() => handleAddPendingItem(pid)}
        disabled={addingId === pid}>
        {addingId === pid ? 'Adding...' : 'Add to My Stall'}
      </Button>
    </div>
  );
})}
  </div>
)}

{!showPendingOnly && viewLayout === 'table' && (
        <div className='col-12 my-3'>
          <TableContainer component={Paper} elevation={1}>
            <Table size="small" className='table-striped'>
                            <TableHead>
                <TableRow>
                  <TableCell>Change Order</TableCell>
                  <TableCell>Item Image</TableCell>
                  <TableCell>Item Name</TableCell>
                  <TableCell>Available Qty</TableCell>
                  <TableCell>Special Communities</TableCell>
                  <TableCell align="center">Affiliate</TableCell>
                  <TableCell align="center">Margin (%)</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell width="10%">Action</TableCell>
                </TableRow>
              </TableHead>

              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="stallItemsDroppable">
                  {(provided) => (
                    <TableBody ref={provided.innerRef} {...provided.droppableProps}>
                      {visibleItems.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={9}><NoRecords /></TableCell>
                        </TableRow>
                      )}

                      {visibleItems.map((row, index) => {
                        const primaryId = row.StallItemId ?? row.Id ?? row.stallItemId ?? `tmp-${index}`;
                        const draggableId = typeof primaryId === 'number' ? primaryId.toString() : primaryId;
                        const imagePath = row.ImagePath ?? row.imagePath ?? (row.ImagePathList && row.ImagePathList.length ? row.ImagePathList[0] : null);
                        const isActive = (row.IsActive !== undefined && row.IsActive !== null)
                          ? row.IsActive
                          : (row.StallItemActive !== undefined ? row.StallItemActive : true);

                                              const isAffiliate = affiliateState[primaryId]?.isAffiliateEnabled ?? false;
                        const marginValue = affiliateState[primaryId]?.marginNumber ?? '';
                        const isMarginLocked = affiliateState[primaryId]?.alreadyPosted ?? false;

                        return (
                          <Draggable
                            key={draggableId}
                            draggableId={draggableId}
                            index={index}
                          >
                            {(providedDraggable, snapshot) => (
                              <TableRow
                                ref={providedDraggable.innerRef}
                                {...providedDraggable.draggableProps}
                                style={{
                                  ...providedDraggable.draggableProps.style,
                                  background: snapshot.isDragging ? 'rgba(0,0,0,0.04)' : undefined
                                }}
                              >
                                <TableCell style={{ width: 40, justifyContent: 'center' }}>
                                  <span {...providedDraggable.dragHandleProps} style={{ cursor: "grab" }}>
                                    <i className="fas fa-grip-vertical text-muted"></i>
                                  </span>
                                </TableCell>

                                <TableCell>
                                  {imagePath ? (
                                    <img src={general.getImageUrl(imagePath)} alt={row.ItemName} className="item-image" />
                                  ) : (
                                    <img src="/assets/images/no-image.png" alt="No Image" className="item-image" />
                                  )}
                                </TableCell>

                                                                                               <TableCell>
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span style={{ fontWeight: 500 }}>{row.ItemName}</span>
                                    {!isActive && (
                                      <Badge badgeContent="Inactive" color="primary" className="ml-2" />
                                    )}
                                  </div>
                                </TableCell>

                                <TableCell><span>{row.CurrentQuantity}</span></TableCell>

                                <TableCell>
                                  <CommunityCapsules
                                    stallItemId={primaryId}
                                    specialCommunities={stallSpecialCommunities}
                                    overrides={itemCommunityOverrides[primaryId] || []}
                                  />
                                </TableCell>

                                {/* Affiliate - Remove Button OR Checkbox */}
{/* Affiliate - Remove Button OR Checkbox */}
<TableCell align="center">
  {isAffiliate ? (
    <Button
      variant="outlined"
      size="small"
      style={{
        fontSize: '11px',
        padding: '4px 10px',
        borderRadius: '15px',
        borderColor: '#f44336',
        color: '#f44336',
        textTransform: 'none',
        minWidth: 'auto'
      }}
      onClick={() => handleRemoveAffiliate(primaryId)}
      disabled={isRemovingAffiliate === primaryId}
    >
      {isRemovingAffiliate === primaryId ? 'Removing...' : 'Remove'}
    </Button>
  ) : (
    <Checkbox
      checked={false}
      onChange={() => handleAffiliateToggle(primaryId)}
      color="primary"
      size="small"
    />
  )}
</TableCell>
                                                                                                                           {/* Clean Margin Input (%) */}
                                                                {/* Clean Margin Input (%) */}
                                <TableCell align="center">
                                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                                    <Tooltip title={isMarginLocked ? "Already posted — margin is locked because resellers may have already cloned this item at this rate" : ""}>
                                      <span>
                                        <TextField
                                          className={classes.marginInput}
                                          variant="outlined"
                                          size="small"
                                          placeholder="%"
                                          disabled={!isAffiliate || isMarginLocked}
                                          value={marginValue}
                                          onChange={(e) => handleMarginInputChange(primaryId, e.target.value)}
                                        />
                                      </span>
                                    </Tooltip>
                                    {isAffiliate && !isMarginLocked && parseFloat(marginValue as string) > 0 && (
                                      !postedAffiliateIds.includes(primaryId) || affiliateState[primaryId]?.isModified
                                    ) && (
                                      <Button
                                        size="small"
                                        variant="contained"
                                        className={`${classes.actionBtn} ${classes.postAffiliateBtn}`}
                                        style={{ height: '26px', minWidth: 'auto', padding: '0 10px', fontSize: '10px', marginRight: 0 }}
                                        onClick={handlePostAffiliatedProducts}
                                        disabled={isSavingAffiliate}
                                      >
                                        {postedAffiliateIds.includes(primaryId) ? 'Update' : 'Post'}
                                      </Button>
                                    )}
                                  </div>
                                </TableCell>

                                {/* Affiliate Post Status */}
                                <TableCell align="center">
                                  {postedAffiliateIds.includes(primaryId) ? (
                                    <span style={{
                                      fontSize: '11px',
                                      fontWeight: 700,
                                      padding: '4px 10px',
                                      borderRadius: '12px',
                                      backgroundColor: '#e8f5e9',
                                      color: '#2e7d32',
                                      whiteSpace: 'nowrap',
                                      display: 'inline-block'
                                    }}>
                                      <i className="fas fa-check-circle mr-1"></i>Posted
                                    </span>
                                  ) : (
                                    <span style={{
                                      fontSize: '11px',
                                      fontWeight: 700,
                                      padding: '4px 10px',
                                      borderRadius: '12px',
                                      backgroundColor: '#f5f5f5',
                                      color: '#9e9e9e',
                                      whiteSpace: 'nowrap',
                                      display: 'inline-block'
                                    }}>
                                      Not Posted
                                    </span>
                                  )}
                                </TableCell>

                                                                <TableCell>
                                  <div className="d-flex justify-content-between">
                                    <Tooltip title="Edit">
                                      <i className="fas fa-edit pointer text-primary" onClick={() => openStallItemForm(primaryId)}></i>
                                    </Tooltip>
                                    <Tooltip title="Add">
                                      <i className="fas fa-plus pointer text-primary" onClick={() => openStallItemBatchList(primaryId)}></i>
                                    </Tooltip>
                                    <Tooltip title="Customize">
                                      <i className="fas fa-tools pointer text-primary" onClick={() => openStallItemCustomize(primaryId)}></i>
                                    </Tooltip>
                                    {postedAffiliateIds.includes(primaryId) && (
                                      <Tooltip title="View on Affiliate Products">
                                        <i className="fas fa-eye pointer" style={{ color: '#ff6f00' }} onClick={() => goToAffiliatePreview()}></i>
                                      </Tooltip>
                                    )}
                                  </div>
                                </TableCell>

                              </TableRow>
                            )}
                          </Draggable>
                        );
                      })}

                      {provided.placeholder}
                    </TableBody>
                  )}
                </Droppable>
              </DragDropContext>
                                                </Table>
          </TableContainer>
        </div>
)}

{!showPendingOnly && viewLayout === 'grid' && (
  <div className='col-12 my-3'>
       <div className="manage-items-grid">
      {visibleItems.length === 0 && (
        <div className="text-center text-muted py-5" style={{ gridColumn: '1 / -1' }}>
          <NoRecords />
        </div>
      )}
      {visibleItems.map((row, index) => {
        const primaryId = row.StallItemId ?? row.Id ?? row.stallItemId ?? `tmp-${index}`;
        const imagePath = row.ImagePath ?? row.imagePath ?? (row.ImagePathList && row.ImagePathList.length ? row.ImagePathList[0] : null);
        const isActive = (row.IsActive !== undefined && row.IsActive !== null)
          ? row.IsActive
          : (row.StallItemActive !== undefined ? row.StallItemActive : true);
        const isAffiliate = affiliateState[primaryId]?.isAffiliateEnabled ?? false;
        const marginValue = affiliateState[primaryId]?.marginNumber ?? '';
        const isMarginLocked = affiliateState[primaryId]?.alreadyPosted ?? false;
        const isPosted = postedAffiliateIds.includes(primaryId);

        return (
                  <div key={primaryId} className="manage-item-card">
                        <div
              className="manage-item-card-img pointer"
              onClick={() => {
                if (imagePath) {
                  setViewerImage(general.getImageUrl(imagePath));
                  setZoomLevel(1);
                  setImageViewerOpen(true);
                }
              }}
              title={imagePath ? 'Click to view full image' : ''}
            >
              {imagePath ? (
                <img src={general.getImageUrl(imagePath)} alt={row.ItemName} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
              ) : (
                <img src="/assets/images/no-image.png" alt="No Image" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
              )}
                            <span className={`manage-item-status-tag ${isActive ? 'is-active' : 'is-inactive'}`}>
                {isActive ? 'Active' : 'Inactive'}
              </span>
            </div>
                        <div className="manage-item-card-body">
              <div className="manage-item-card-title">{row.ItemName}</div>
              <div className="manage-item-card-qty">Qty: {row.CurrentQuantity}</div>

              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                {isAffiliate ? (
                  <Button
                    variant="outlined"
                    size="small"
                    style={{ fontSize: '11px', padding: '3px 10px', borderRadius: 15, borderColor: '#f44336', color: '#f44336', textTransform: 'none', minWidth: 'auto' }}
                    onClick={() => handleRemoveAffiliate(primaryId)}
                    disabled={isRemovingAffiliate === primaryId}
                  >
                    {isRemovingAffiliate === primaryId ? 'Removing...' : 'Remove'}
                  </Button>
                ) : (
                  <Checkbox
                    checked={false}
                    onChange={() => handleAffiliateToggle(primaryId)}
                    color="primary"
                    size="small"
                  />
                )}
                <span style={{
                  fontSize: '10px', fontWeight: 700, padding: '3px 8px', borderRadius: 10,
                  backgroundColor: isPosted ? '#e8f5e9' : '#f5f5f5',
                  color: isPosted ? '#2e7d32' : '#9e9e9e'
                }}>
                  {isPosted ? 'Posted' : 'Not Posted'}
                </span>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <TextField
                  className={classes.marginInput}
                  variant="outlined"
                  size="small"
                  placeholder="%"
                  disabled={!isAffiliate || isMarginLocked}
                  value={marginValue}
                  onChange={(e) => handleMarginInputChange(primaryId, e.target.value)}
                />
                {isAffiliate && !isMarginLocked && parseFloat(marginValue as string) > 0 && (
                  !isPosted || affiliateState[primaryId]?.isModified
                ) && (
                  <Button
                    size="small"
                    variant="contained"
                    className={`${classes.actionBtn} ${classes.postAffiliateBtn}`}
                    style={{ height: '26px', minWidth: 'auto', padding: '0 10px', fontSize: '10px', marginRight: 0 }}
                    onClick={handlePostAffiliatedProducts}
                    disabled={isSavingAffiliate}
                  >
                    {isPosted ? 'Update' : 'Post'}
                  </Button>
                )}
              </div>

                            <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: 10, paddingTop: 8, borderTop: '1px solid #f1f1f1' }}>
                <Tooltip title="Edit">
                  <i className="fas fa-edit pointer text-primary" onClick={() => openStallItemForm(primaryId)}></i>
                </Tooltip>
                <Tooltip title="Add">
                  <i className="fas fa-plus pointer text-primary" onClick={() => openStallItemBatchList(primaryId)}></i>
                </Tooltip>
                <Tooltip title="Customize">
                  <i className="fas fa-tools pointer text-primary" onClick={() => openStallItemCustomize(primaryId)}></i>
                </Tooltip>
                {isPosted && (
                  <Tooltip title="View on Affiliate Products">
                    <i className="fas fa-eye pointer" style={{ color: '#ff6f00' }} onClick={() => goToAffiliatePreview()}></i>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
)}

        <div className="col-12 my-3 text-center">
          {!showPendingOnly && stallItems && stallItems.length === 0 && <span className='font-20'><b>No items</b></span>}
        </div>
      </div>

           <Dialog
        open={imageViewerOpen}
        onClose={() => setImageViewerOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{ style: { background: '#1e1e1e', borderRadius: '8px', overflow: 'hidden' } }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 14px', background: '#2b2b2b' }}>
          <span style={{ color: '#fff', fontSize: '14px', fontWeight: 600 }}>Image Preview</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Button style={{ color: '#fff', minWidth: '40px' }} onClick={() => setZoomLevel(z => Math.max(0.5, z - 0.25))}>
              <i className="fas fa-search-minus"></i>
            </Button>
            <span style={{ color: '#bbb', fontSize: '12px', minWidth: '45px', textAlign: 'center' }}>
              {Math.round(zoomLevel * 100)}%
            </span>
            <Button style={{ color: '#fff', minWidth: '40px' }} onClick={() => setZoomLevel(z => Math.min(4, z + 0.25))}>
              <i className="fas fa-search-plus"></i>
            </Button>
            <Button style={{ color: '#fff', minWidth: '40px' }} onClick={() => setZoomLevel(1)}>
              <i className="fas fa-sync-alt"></i>
            </Button>
            <Button style={{ color: '#fff', minWidth: '40px' }} onClick={() => setImageViewerOpen(false)}>
              <i className="fas fa-times"></i>
            </Button>
          </div>
        </div>
        <div style={{ height: '75vh', overflow: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1e1e1e' }}>
          <img
            src={viewerImage}
            alt="Preview"
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              transition: 'transform 0.2s ease',
              transform: `scale(${zoomLevel})`,
              cursor: zoomLevel > 1 ? 'zoom-out' : 'zoom-in'
            }}
          />
        </div>
      </Dialog>

      <Drawer anchor={"right"} classes={{ paper: classes.drawerWidth }} open={stallItemFormOpen} onClose={handleStallItemFormClose}>
        <StallItemForm stallItemId={stallItemId} handleStallItemFormClose={handleStallItemFormClose} />
      </Drawer>

      <Drawer anchor={"right"} classes={{ paper: classes.drawerWidth }} open={stallItemBatchFormOpen} onClose={handleStallItemBatchFormClose}>
        <StallItemBatchForm stallItemId={stallItemId} handleStallItemBatchFormClose={handleStallItemBatchFormClose} />
      </Drawer>

      <Drawer anchor={"right"} classes={{ paper: classes.drawerWidth }} open={newCatItemFormOpen} onClose={handleNewCatFormClose}>
        <NewCategoryItemForm
          serviceId={newCatFormServiceId}
          stallId={currentContext.stallId}
          serviceRequestType={newCatFormServiceRequestType}
          selectedCategoryId={selectedCategoryId}
          selectedCategoryName={selectedCategoryName}
          onSaveFormCallback={handleNewCatFormSave}
          handleFormClose={handleNewCatFormClose}
        />
      </Drawer>
    </div>
  );
};

export default ManageItems;